// extracted by mini-css-extract-plugin
module.exports = {"main":"Sell_main__29UHi","main__steps":"Sell_main__steps__24w_p","main__content":"Sell_main__content__39Pab","main__action":"Sell_main__action__1x20D"};